import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react';
import { Upload } from 'lucide-react';
import React, { FC } from 'react';

import { useGetAdAssets } from '../../../../queries';
import { useAssetUpload } from '../../hooks';
import { AssetGrid, AssetThumb, AssetTile, EmptyPanelHint } from './Editor.styled';

interface ImagePickerModalProps {
  onPick: (url: string) => void;
  onClose: () => void;
}

/**
 * Wybór zdjęcia do pustej ramki na planszy.
 *
 * Zdjęcie wchodzi w istniejący element, więc dziedziczy jego rozmiar,
 * zaokrąglenie i sposób kadrowania — dlatego szablonowe „miejsce na zrzut
 * ekranu" wypełnia się dokładnie tak, jak zaprojektował je szablon.
 */
export const ImagePickerModal: FC<ImagePickerModalProps> = ({ onPick, onClose }) => {
  const { data: assets = [] } = useGetAdAssets();
  const { inputRef, accept, isUploading, openPicker, handleFiles } = useAssetUpload();

  return (
    <Modal isOpen size="lg" radius="sm" onClose={onClose}>
      <ModalContent>
        <ModalHeader>Wybierz zdjęcie do ramki</ModalHeader>
        <ModalBody>
          <input
            ref={inputRef}
            type="file"
            accept={accept}
            hidden
            onChange={async (event) => {
              const uploaded = await handleFiles(event.target.files);
              if (uploaded[0]) onPick(uploaded[0].url);
            }}
          />
          <Button
            size="sm"
            radius="sm"
            variant="flat"
            className="self-start"
            startContent={<Upload size={16} />}
            isLoading={isUploading}
            onPress={openPicker}
          >
            Wgraj nowe zdjęcie
          </Button>

          {assets.length === 0 ? (
            <EmptyPanelHint>Biblioteka jest pusta. Wgraj plik albo poszukaj w banku zdjęć.</EmptyPanelHint>
          ) : (
            <AssetGrid>
              {assets.map((asset) => (
                <AssetTile key={asset.id}>
                  <AssetThumb type="button" title={asset.name} onClick={() => onPick(asset.url)}>
                    <img src={asset.url} alt="" crossOrigin="anonymous" />
                  </AssetThumb>
                </AssetTile>
              ))}
            </AssetGrid>
          )}
        </ModalBody>
        <ModalFooter>
          <Button size="sm" radius="sm" variant="light" onPress={onClose}>
            Anuluj
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
